import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import { Link, useSidebarOpenState } from '@backstage/core-components';
import { Grid, Text } from '@backstage/ui';
import { useSidebarStyles } from './sidebarStyles';

// `UserSettingsSignInAvatar`/`useUserProfile` both call catalogApi.getEntityByRef()
// for the signed-in user's entity, even for the guest identity. Under `yarn start`
// there's no backend to serve that request, so it fails loudly (an alert toast:
// "Failed to load user identity"). Show a static placeholder instead — no backend
// call at all — when `app.localDev.guestMode` is set (local-dev-server-only.yaml).
export const GuestUserSettingsRow = () => {
  const classes = useSidebarStyles();
  const { isOpen } = useSidebarOpenState();

  const avatar = <Avatar style={{ width: 36, height: 36 }}><PersonIcon /></Avatar>;

  return (
      <Link to='/settings' underline='none'>
        {isOpen ?
          <Grid.Root columns="3" gap="2" style={{width: '100%', alignItems: 'center',}}>
              <Grid.Item colSpan="1" style={{alignSelf: 'center', justifyContent: 'center'}}>
                {avatar}
              </Grid.Item>
              <Grid.Item colSpan="2">
                <Text className={classes.sidebarNavItemUser}>Guest User</Text>
              </Grid.Item>
          </Grid.Root>
          :
          <Grid.Root columns="2" gap="2" style={{width: '100%', alignItems: 'center'}}>
            <Grid.Item>
              {avatar}
            </Grid.Item>
          </Grid.Root>
        }
      </Link>
  )
}
